import {
	CreateReleaseScriptsApiArg,
	DownloadCustomLovsLovCustomAttributeLovApiArg,
	DecideApiArg,
	DecideApiResponse,
	ExecuteMergeApiArg,
	ExecuteMergeApiResponse,
	mddApiSliceGeneratedV2,
} from './mddApiSliceGeneratedV2'
import './relationMock'

export const mddApiV2 = mddApiSliceGeneratedV2
	.enhanceEndpoints({
		addTagTypes: [
			'Templates',
			'Tenant',
			'Views',
			'Mappings',
			'Secrets',
			'Releases',
			'Structure',
			'Branches',
			'Systems',
			'MergeRequests',
		],
		endpoints: {
			// Template endpoints
			createTemplate: {
				invalidatesTags: ['Templates'],
			},
			getAllTemplates: {
				providesTags: ['Templates'],
			},
			updateTemplate: {
				invalidatesTags: ['Templates'],
			},
			deleteTemplate: {
				invalidatesTags: ['Templates'],
			},
			getTemplate: {
				providesTags: ['Templates'],
			},
			postTemplateLock: {
				invalidatesTags: ['Templates'],
			},
			postTemplateUnlock: {
				invalidatesTags: ['Templates'],
			},
			postTemplatePush: {
				invalidatesTags: ['Templates'],
			},
			getTemplateHistory: {
				providesTags: ['Templates'],
			},
			getTemplateHistoryDetail: {
				providesTags: ['Templates'],
			},
			// Tenant endpoints
			getTenant: {
				providesTags: ['Tenant'],
			},
			updateTenant: {
				invalidatesTags: ['Tenant'],
			},
			// View endpoints — generated names are *View (GET /v2/branch/{branchId}/view/{id}).
			getStructureDetailView: {
				providesTags: (_result, _error, arg) => [
					{ type: 'Views', id: arg.structureId },
				],
			},
			getViewOverviewView: {
				providesTags: (_result, _error, arg) => [
					{ type: 'Views', id: arg.structureId },
				],
			},
			getViewColumnsView: {
				providesTags: (_result, _error, arg) => [
					{ type: 'Views', id: arg.structureId },
				],
			},
			getViewSourcesView: {
				providesTags: (_result, _error, arg) => [
					{ type: 'Views', id: arg.structureId },
				],
			},
			getViewSourcesDataView: {
				providesTags: (_result, _error, arg) => [
					{ type: 'Views', id: arg.structureId },
				],
			},
			getViewPermissionsView: {
				providesTags: (_result, _error, arg) => [
					{ type: 'Views', id: arg.structureId },
				],
			},
			updateViewView: {
				invalidatesTags: (_result, _error, arg) => [
					{ type: 'Views', id: arg.structureId },
				],
			},
			updateViewOverviewView: {
				invalidatesTags: (_result, _error, arg) => [
					{ type: 'Views', id: arg.structureId },
				],
			},
			updateViewColumnsView: {
				invalidatesTags: (_result, _error, arg) => [
					{ type: 'Views', id: arg.structureId },
				],
			},
			updateViewSourceItemsView: {
				invalidatesTags: (_result, _error, arg) => [
					{ type: 'Views', id: arg.structureId },
				],
			},
			updateViewSourcesDataView: {
				invalidatesTags: (_result, _error, arg) => [
					{ type: 'Views', id: arg.structureId },
				],
			},
			setViewPermissionView: {
				invalidatesTags: (_result, _error, arg) => [
					{ type: 'Views', id: arg.structureId },
				],
			},
			deleteViewPermissionView: {
				invalidatesTags: (_result, _error, arg) => [
					{ type: 'Views', id: arg.structureId },
				],
			},
			// Mapping endpoints
			getStructureDetailMapping: {
				providesTags: ['Mappings'],
			},
			updateMappingMapping: {
				invalidatesTags: ['Mappings'],
			},
			// Secret endpoints
			getSecrets: {
				providesTags: ['Secrets'],
			},
			getSecret: {
				providesTags: ['Secrets'],
			},
			createSecret: {
				invalidatesTags: ['Secrets'],
			},
			updateSecret: {
				invalidatesTags: ['Secrets'],
			},
			deleteSecret: {
				invalidatesTags: ['Secrets'],
			},
			// Release endpoints
			getSystemRelease: {
				providesTags: ['Releases'],
			},
			updateSystemRelease: {
				invalidatesTags: ['Releases'],
			},
			deleteSystemRelease: {
				invalidatesTags: ['Releases'],
			},
			getDeploymentPackages: {
				providesTags: ['Releases'],
			},
			createDeploymentPackage: {
				invalidatesTags: ['Releases'],
			},
			updateDeploymentPackage: {
				invalidatesTags: ['Releases'],
			},
			getReleaseStructures: {
				providesTags: ['Releases'],
			},
			getReleaseEnvironments: {
				providesTags: ['Releases'],
			},
			// Structure endpoints — keep existing hook names; generated ops are *StructureV2
			getStructureMetadataStructureV2: {
				providesTags: ['Structure'],
			},
			getChildrenStructureV2: {
				providesTags: ['Structure'],
			},
			createStructureStructureV2: {
				invalidatesTags: ['Structure'],
			},
			moveNodeStructureV2: {
				invalidatesTags: ['Structure'],
			},
			getStructureTreeStructureV2: {
				providesTags: ['Structure'],
			},
			lockStructureStructureV2: {
				invalidatesTags: ['Structure'],
			},
			unLockStructureStructureV2: {
				invalidatesTags: ['Structure'],
			},
			bulkLockStructureV2: {
				invalidatesTags: ['Structure'],
			},
			bulkUnlockStructureV2: {
				invalidatesTags: ['Structure'],
			},
			getStructuresStructureV2: {
				providesTags: ['Structure'],
			},
			getFullTreeStructureV2: {
				providesTags: ['Structure'],
			},
			getSystems: {
				providesTags: ['Systems'],
			},
			createSystem: {
				invalidatesTags: ['Systems'],
			},
			getParentSystemStructureV2: {
				providesTags: ['Structure'],
			},
			getStructureHistoryStructureV2: {
				providesTags: ['Structure'],
			},
			createStructureHistoryStructureV2: {
				invalidatesTags: ['Structure', 'MergeRequests'],
			},
			getStructureHistoryWithDeploymentStructureV2: {
				providesTags: ['Structure'],
			},
			getStructureHistoryById: {
				providesTags: ['Structure'],
			},
			prePushValidationStructureV2: {
				providesTags: ['Structure'],
			},
			asyncStructurePreviewStructureV2: {
				invalidatesTags: ['Structure'],
			},
			getBranches: {
				providesTags: (result) =>
					result?.content
						? [
								...result.content
									.filter((branch) => branch.id != null)
									.map((branch) => ({
										type: 'Branches' as const,
										id: branch.id,
									})),
								{ type: 'Branches', id: 'LIST' },
							]
						: [{ type: 'Branches', id: 'LIST' }],
			},
			getBranch: {
				providesTags: (_result, _error, arg) => [
					{ type: 'Branches', id: arg.branchId },
				],
			},
			createBranch: {
				invalidatesTags: [{ type: 'Branches', id: 'LIST' }],
			},
			updateBranch: {
				invalidatesTags: (_result, _error, arg) => [
					{ type: 'Branches', id: arg.branchId },
					{ type: 'Branches', id: 'LIST' },
				],
			},
			rebaseBranch: {
				invalidatesTags: (_result, _error, arg) => [
					{ type: 'Branches', id: arg.branchId },
					{ type: 'Branches', id: 'LIST' },
					'Structure',
				],
			},
			cherryPick: {
				invalidatesTags: (_result, _error, arg) => [
					{ type: 'Branches', id: arg.branchId },
					{ type: 'Branches', id: 'LIST' },
					'Structure',
				],
			},
			getBranchChanges: {
				providesTags: ['Structure'],
			},
			getBranchChangesBetween: {
				providesTags: ['Structure'],
			},
			deleteBranch: {
				invalidatesTags: (_result, _error, arg) => [
					{ type: 'Branches', id: arg.branchId },
					{ type: 'Branches', id: 'LIST' },
				],
			},
			activateBranch: {
				invalidatesTags: (_result, _error, arg) => [
					{ type: 'Branches', id: arg.branchId },
					{ type: 'Branches', id: 'LIST' },
				],
			},
			archiveBranch: {
				invalidatesTags: (_result, _error, arg) => [
					{ type: 'Branches', id: arg.branchId },
					{ type: 'Branches', id: 'LIST' },
				],
			},
			lockBranch: {
				invalidatesTags: (_result, _error, arg) => [
					{ type: 'Branches', id: arg.branchId },
					{ type: 'Branches', id: 'LIST' },
				],
			},
			unlockBranch: {
				invalidatesTags: (_result, _error, arg) => [
					{ type: 'Branches', id: arg.branchId },
					{ type: 'Branches', id: 'LIST' },
				],
			},
			createMergeRequest: {
				invalidatesTags: ['MergeRequests'],
			},
			getMergeRequest: {
				providesTags: (_result, _error, arg) => [
					{ type: 'MergeRequests', id: arg.mergeRequestId },
					'MergeRequests',
				],
			},
			getMergeRequestsForTargetBranch: {
				providesTags: ['MergeRequests'],
			},
			getMergeRequestsForBranchPair: {
				providesTags: ['MergeRequests'],
			},
			getMergeRequestsInSystem: {
				providesTags: (result) => [
					'MergeRequests',
					{ type: 'MergeRequests', id: 'LIST' },
					...(result?.content ?? [])
						.filter((mergeRequest) => mergeRequest.id != null)
						.map((mergeRequest) => ({
							type: 'MergeRequests' as const,
							id: mergeRequest.id,
						})),
				],
			},
			getApprovals: {
				providesTags: (_result, _error, arg) => [
					{ type: 'MergeRequests', id: arg.mergeRequestId },
					'MergeRequests',
				],
			},
			getResolutions: {
				providesTags: (_result, _error, arg) => [
					{ type: 'MergeRequests', id: arg.mergeRequestId },
					'MergeRequests',
				],
			},
			saveResolution: {
				invalidatesTags: (_result, _error, arg) => [
					{ type: 'MergeRequests', id: arg.mergeRequestId },
					'MergeRequests',
				],
			},
			getEventsForMergeRequest: {
				providesTags: (_result, _error, arg) => [
					{ type: 'MergeRequests', id: arg.mergeRequestId },
					'MergeRequests',
				],
			},
			decide: {
				invalidatesTags: ['MergeRequests'],
			},
			executeMerge: {
				invalidatesTags: ['MergeRequests', 'Structure', 'Branches'],
			},
			updateMergeRequestStatus: {
				invalidatesTags: ['MergeRequests'],
			},
			markStale: {
				invalidatesTags: ['MergeRequests'],
			},
			recalculateDiff: {
				invalidatesTags: ['MergeRequests'],
			},
		},
	})
	.injectEndpoints({
		endpoints: (builder) => ({
			decide: builder.mutation<
				DecideApiResponse,
				DecideApiArg & { userId: number }
			>({
				query: (args) => ({
					url: `/v2/merge-request/${args.mergeRequestId}/decision`,
					method: 'POST',
					params: {
						decision: args.decision,
						comment: args.comment,
						userId: args.userId,
					},
				}),
				invalidatesTags: ['MergeRequests'],
			}),
			executeMerge: builder.mutation<
				ExecuteMergeApiResponse,
				ExecuteMergeApiArg & { userId: number }
			>({
				query: (args) => ({
					url: `/v2/merge-request/${args.mergeRequestId}/execute`,
					method: 'POST',
					params: {
						userId: args.userId,
					},
				}),
				invalidatesTags: ['MergeRequests', 'Structure', 'Branches'],
			}),
			downloadCustomLovsLovCustomAttributeLov: builder.query<
				string,
				DownloadCustomLovsLovCustomAttributeLovApiArg
			>({
				query: (queryArg) => ({
					url: `/v2/lov/custom-attr-lov/export`,
					params: {
						search: queryArg.search,
					},
					responseHandler: (response: Response) => response.text(),
				}),
			}),
		}),
		overrideExisting: true,
	})

export const {
	// Template hooks
	useGetAllTemplatesQuery,
	useGetTemplateQuery,
	useCreateTemplateMutation,
	useUpdateTemplateMutation,
	useDeleteTemplateMutation,
	usePostTemplateLockMutation,
	usePostTemplateUnlockMutation,
	usePostTemplatePushMutation,
	useGetTemplateHistoryQuery,
	useGetTemplateHistoryDetailQuery,
	useLazyGetTemplateHistoryQuery,
	useLazyGetTemplateHistoryDetailQuery,
	// Tenant hooks
	useGetTenantQuery,
	useUpdateTenantMutation,
	useLazyGetTenantQuery,
	// View hooks (generated *View names, keep previous public names)
	useGetStructureDetailViewQuery: useGetStructureDetailQuery,
	useUpdateViewViewMutation: useUpdateViewMutation,
	useGetViewSourcesViewQuery: useGetViewSourcesQuery,
	useUpdateViewSourceItemsViewMutation: useUpdateViewSourceItemsMutation,
	useAddViewSourceItemViewMutation: useAddViewSourceItemMutation,
	useUpdateViewSourceItemViewMutation: useUpdateViewSourceItemMutation,
	useDeleteViewSourceItemViewMutation: useDeleteViewSourceItemMutation,
	useGetViewSourcesDataViewQuery: useGetViewSourcesDataQuery,
	useUpdateViewSourcesDataViewMutation: useUpdateViewSourcesDataMutation,
	useGetViewOverviewViewQuery: useGetViewOverviewQuery,
	useUpdateViewOverviewViewMutation: useUpdateViewOverviewMutation,
	useGetViewColumnsViewQuery: useGetViewColumnsQuery,
	useUpdateViewColumnsViewMutation: useUpdateViewColumnsMutation,
	useAddViewColumnViewMutation: useAddViewColumnMutation,
	useUpdateViewColumnViewMutation: useUpdateViewColumnMutation,
	useUpdateViewColumnView1Mutation: useUpdateViewColumn1Mutation,
	useLazyGetStructureDetailViewQuery: useLazyGetStructureDetailQuery,
	useGetViewPermissionsViewQuery: useGetViewPermissionsQuery,
	useSetViewPermissionViewMutation: useSetViewPermissionMutation,
	useDeleteViewPermissionViewMutation: useDeleteViewPermissionMutation,
	// Mapping hooks
	useGetStructureDetailMappingQuery: useGetStructureDetail1Query,
	useUpdateMappingMappingMutation: useUpdateMappingMutation,
	useGetMappingSourcesMappingQuery: useGetMappingSourcesQuery,
	useUpdateMappingSourceItemsMappingMutation: useUpdateMappingSourceItemsMutation,
	useAddMappingSourceItemMappingMutation: useAddMappingSourceItemMutation,
	useUpdateMappingSourceItemMappingMutation: useUpdateMappingSourceItemMutation,
	useDeleteMappingSourceItemMappingMutation: useDeleteMappingSourceItemMutation,
	useGetMappingSourcesDataMappingQuery: useGetMappingSourcesDataQuery,
	useUpdateMappingSourcesDataMappingMutation: useUpdateMappingSourcesDataMutation,
	useGetMappingOverviewMappingQuery: useGetMappingOverviewQuery,
	useUpdateMappingOverviewMappingMutation: useUpdateMappingOverviewMutation,
	useGetMappingOtherScriptsMappingQuery: useGetMappingOtherScriptsQuery,
	useUpdateMappingOtherScriptsMappingMutation: useUpdateMappingOtherScriptsMutation,
	useGetMappingColumnsMappingQuery: useGetMappingColumnsQuery,
	useUpdateMappingColumnsMappingMutation: useUpdateMappingColumnsMutation,
	useAddMappingColumnMappingMutation: useAddMappingColumnMutation,
	useUpdateMappingColumnMappingMutation: useUpdateMappingColumnMutation,
	useUpdateMappingColumnMapping1Mutation: useUpdateMappingColumn1Mutation,
	useLazyGetStructureDetailMappingQuery: useLazyGetStructureDetail1Query,
	useGetMappingPermissionsMappingQuery: useGetMappingPermissionsQuery,
	useSetMappingPermissionMappingMutation: useSetMappingPermissionMutation,
	useDeleteMappingPermissionMappingMutation: useDeleteMappingPermissionMutation,
	// Secret hooks
	useGetSecretsQuery,
	useGetSecretQuery,
	useCreateSecretMutation,
	useUpdateSecretMutation,
	useDeleteSecretMutation,
	useLazyGetSecretsQuery,
	useLazyGetSecretQuery,
	// Release hooks
	useGetSystemReleaseQuery,
	useUpdateSystemReleaseMutation,
	useDeleteSystemReleaseMutation,
	useGetDeploymentPackagesQuery,
	useCreateDeploymentPackageMutation,
	useUpdateDeploymentPackageMutation,
	useGetReleaseStructuresQuery,
	useGetReleaseEnvironmentsQuery,
	useCreateReleaseEnvironmentMutation,
	useUpdateReleaseEnvironmentMutation,
	useDeleteReleaseEnvironmentMutation,
	useCreateReleaseScriptsMutation,
	useLazyDownloadCustomLovsLovCustomAttributeLovQuery,
	useCreateDeploymentsMutation,
	usePushReleaseToGitMutation,
	useChangeReleaseStatusMutation,
	useAddStructureToReleaseMutation,
	useDeleteReleaseStructureMutation,
	useLazyGetSystemReleaseQuery,
	useLazyGetDeploymentPackagesQuery,
	useLazyGetReleaseStructuresQuery,
	useLazyGetReleaseEnvironmentsQuery,
	// Structure hooks (generated *StructureV2 names, keep previous public names)
	useGetStructureMetadataStructureV2Query: useGetStructureMetadataQuery,
	useGetChildrenStructureV2Query: useGetChildrenQuery,
	useCreateStructureStructureV2Mutation: useCreateStructureMutation,
	useGetStructureTreeStructureV2Query: useGetStructureTreeQuery,
	useLockStructureStructureV2Mutation: useLockStructureMutation,
	useUnLockStructureStructureV2Mutation: useUnLockStructureMutation,
	useMoveNodeStructureV2Mutation,
	useGetStructureHistoryStructureV2Query: useGetStructureHistoryQuery,
	useCreateStructureHistoryStructureV2Mutation: useCreateStructureHistoryMutation,
	useCreateSystemMutation,
	useGetSystemsQuery,
	useLazyGetSystemsQuery,
	useUndeleteStructureMutation,
	useGetFullTreeStructureV2Query: useGetFullTreeQuery,
	useGetDeletedStructuresQuery,
	useGetParentSystemStructureV2Query: useGetParentSystemQuery,
	useGetStructureHistoryWithDeploymentStructureV2Query: useGetStructureHistoryWithDeploymentQuery,
	usePrePushValidationStructureV2Query: usePrePushValidationQuery,
	useLazyGetStructureMetadataStructureV2Query: useLazyGetStructureMetadataQuery,
	useLazyGetChildrenStructureV2Query: useLazyGetChildrenQuery,
	useLazyGetStructureTreeStructureV2Query: useLazyGetStructureTreeQuery,
	useLazyGetStructureHistoryStructureV2Query: useLazyGetStructureHistoryQuery,
	useCompareStructureHistoryStructureV2Query: useCompareStructureHistoryQuery,
	useLazyCompareStructureHistoryStructureV2Query: useLazyCompareStructureHistoryQuery,
	useLazyGetFullTreeStructureV2Query: useLazyGetFullTreeQuery,
	useLazyGetDeletedStructuresQuery,
	useLazyGetParentSystemStructureV2Query: useLazyGetParentSystemQuery,
	useLazyGetStructureHistoryWithDeploymentStructureV2Query: useLazyGetStructureHistoryWithDeploymentQuery,
	useGetStructureHistoryByIdQuery,
	useLazyGetStructureHistoryByIdQuery,
	useLazyPrePushValidationStructureV2Query: useLazyPrePushValidationQuery,
	useGetStructuresStructureV2Query: useGetStructuresQuery,
	useLazyGetStructuresStructureV2Query: useLazyGetStructuresQuery,
	useGenerateScriptsStructureV2Mutation: useGenerateScriptsMutation,
	// Bulk lock/unlock hooks
	useBulkLockStructureV2Mutation: useBulkLockMutation,
	useBulkUnlockStructureV2Mutation: useBulkUnlockMutation,
	// Diagram hooks
	useGetDataForDiagramQuery,
	useLazyGetDataForDiagramQuery,
	useAsyncStructurePreviewStructureV2Mutation: useAsyncStructurePreviewMutation,
	// Expectation catalog hooks
	useGetExpectationsQuery,
	useLazyGetExpectationsQuery,
	useGetProvidersQuery,
	useLazyGetProvidersQuery,
	// Import hooks
	useCheckJsonMutation,
	useImportStructuresMutation,
	// Branch hooks
	useGetBranchesQuery,
	useLazyGetBranchesQuery,
	useCreateBranchMutation,
	useGetBranchQuery,
	useLazyGetBranchQuery,
	useUpdateBranchMutation,
	useRebaseBranchMutation,
	useCherryPickMutation,
	usePreviewCherryPickMutation,
	useDeleteBranchMutation,
	useActivateBranchMutation,
	useArchiveBranchMutation,
	useLockBranchMutation,
	useUnlockBranchMutation,
	useGetBranchChangesQuery,
	useLazyGetBranchChangesQuery,
	useGetBranchChangesBetweenQuery,
	useLazyGetBranchChangesBetweenQuery,
	useCreateMergeRequestMutation,
	useGetMergeRequestQuery,
	useLazyGetMergeRequestQuery,
	useGetMergeRequestsForTargetBranchQuery,
	useLazyGetMergeRequestsForTargetBranchQuery,
	useGetMergeRequestsForBranchPairQuery,
	useGetMergeRequestsInSystemQuery,
	useLazyGetMergeRequestsInSystemQuery,
	useGetApprovalsQuery,
	useGetResolutionsQuery,
	useSaveResolutionMutation,
	useDecideMutation,
	useExecuteMergeMutation,
	useUpdateMergeRequestStatusMutation,
	useGetEventsForMergeRequestQuery,
	useRecalculateDiffMutation,
	useMarkStaleMutation,
	useGetNodeRelationsRelationQuery,
	useCreateRelationRelationMutation,
	useDeleteRelationRelationMutation,
	useUpdateRelationRelationMutation,
} = mddApiV2
